import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getComplaintType = async () => {  
    try {
        const ComplaintType: any = await api
        .get(ApiConstant.getComplaintType)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get complaint type data.', error);
         });
        const response = ComplaintType != null ? ComplaintType : null;        
        return response;
    }
    catch (e) {
        console.log('error in getComplaintType');
        return [];
    } 
};

const addType = async (complaintTypes: any) => {
    try {
      const addType: any = await api
        .post(ApiConstant.createComplaintType, complaintTypes)
        .then((result: any) => {
          if (result) 
            return result.data;
          else 
          return null;
        })
        .catch(function (error: any) {
          console.error("error creating complaint type data.", error);
        });
      const response = addType != null ? addType : null;
      return response;
    } catch {
      console.log("error in add user complaint type");
      return [];
    }
  };

  const updateComplaintType = async (data: any) => {
    try {
        const res: any = await api
        .put(ApiConstant.updateComplaintType, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating complaint type', error);
         });
        const response = res != null ? res : null;        
        return response;
    }
    catch
    {
        console.log('error in update complaint type');
        return [];
    }
};



const deleteComplaintType = async (complaintTypeId: number): Promise<boolean> => {
  try {
    console.warn("Calling DELETE:", ApiConstant.deletecomplaintType + complaintTypeId);
    
    const res = await api.delete(ApiConstant.deletecomplaintType + complaintTypeId);

    // ✅ Check if API returned success
    if (res?.data?.isSuccess) {
      return true;
    } else {
      console.error("Delete failed:", res?.data?.message || "Unknown error");
      return false;
    }
  } catch (error) {
    console.error("Error deleting complaint type:", error);
    return false;
  }
};




// const deleteComplaintType = async (complaintTypeId: number): Promise<boolean> => {
//   try {
//     console.warn(ApiConstant.deletecomplaintType + complaintTypeId);
    
//     const res = await api.delete(ApiConstant.deletecomplaintType + complaintTypeId);

//     if (res && res.data) {
//       return true;  
//     } else {
//       return true;  
//     }
//   } catch (error) {
//     console.error("Error deleting complaint type:", error);
//     return true;  
//   }
// };





const types = {
    getComplaintType,
    addType,
    updateComplaintType,
    deleteComplaintType,
}

export default types;